import { DialogDescription } from '@/components/ui/dialog'

type PackagingDocumentUploadDialogInstructionsProps = {
  intro: string
  requirementFormats: string
  requirementMaxSize: string
}

export function PackagingDocumentUploadDialogInstructions({
  intro,
  requirementFormats,
  requirementMaxSize,
}: PackagingDocumentUploadDialogInstructionsProps) {
  return (
    <DialogDescription className='space-y-2'>
      <span className='block'>{intro}</span>
      <ul className='list-disc space-y-1 ps-5'>
        <li>{requirementFormats}</li>
        <li>{requirementMaxSize}</li>
      </ul>
    </DialogDescription>
  )
}
